import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./i18n";
import { StateProvider } from "./Context/StateContext";
import { HelmetProvider } from "react-helmet-async";
import CustomPopup from "./Components/Layouts/CustomPopup/CustomPopup";
import {
  ErrorBoundary,
  ErrorFallback,
  myErrorHandler,
} from "./Components/Common/ErrorBoundary/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
localStorage.setItem("laung", "en");
root.render(
  <React.StrictMode>
    <CustomPopup />
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <HelmetProvider>
          <StateProvider>
            <ErrorBoundary
              FallbackComponent={ErrorFallback}
              onError={myErrorHandler}
            >
              <App />
            </ErrorBoundary>
          </StateProvider>
        </HelmetProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
